import { render, staticRenderFns } from "./DynamicImage.vue?vue&type=template&id=8805f09e"
import script from "./DynamicImage.vue?vue&type=script&lang=js"
export * from "./DynamicImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports